__turbopack_context__.v({
  "fade": "EntryEffectWrapper-module-scss-module__VzDmzG__fade",
  "standard": "EntryEffectWrapper-module-scss-module__VzDmzG__standard",
  "visible": "EntryEffectWrapper-module-scss-module__VzDmzG__visible",
});
